module.exports = __webpack_public_path__ + "img/i-phone-large.6c82eeda.svg";